import type { AxiosError } from "axios";
import { postValidations } from "./postValidations";
import type { EmailValidationResponse, EmailValidationResult } from "./types";

const mapEmailValidation = (
  response: EmailValidationResponse,
  email: string
): EmailValidationResult => {
  const validation = response?.data?.validations?.find(
    (item) => item.name === "email_validation" && item.value === email
  );

  if (response.code === "V-000" && validation?.code === "EM_001") {
    return { valid: true, message: "Correo electrónico disponible para crear usuario" };
  }

  // Los mensajes de rechazo distinguen usuario existente y otra solicitud en curso.
  if (validation?.code === "EM_002" && validation.message?.trim()) {
    return { valid: false, message: validation.message };
  }

  throw new Error("No se pudo verificar la disponibilidad del correo electrónico.");
};

export const validateRepresentativeEmailService = async (
  email: string,
  signal?: AbortSignal
): Promise<EmailValidationResult> => {
  const value = email.trim();
  let data: EmailValidationResponse;

  try {
    const response = await postValidations<EmailValidationResponse>(
      [{ name: "email_validation", value }],
      signal
    );
    data = response.data;
  } catch (error) {
    const response = (error as AxiosError<EmailValidationResponse>).response;
    if (response?.status !== 409) throw error;
    data = response.data;
  }

  return mapEmailValidation(data, value);
};
